<ng-template let-association="association" #associationlabel>
	<h2>
		@if (autoNumber) {
			{{ getIndex(association) }}
		}
		{{ association.targetElement.label }}
		@if (association.changeMarker && association.changeMarker.added) {
			<span class="badge added-badge" translate="process.compare.added"></span>
		}
		@if (association.changeMarker && association.changeMarker.deleted) {
			<span class="badge deleted-badge" translate="process.compare.deleted"></span>
		}
	</h2>
</ng-template>

@if (self$ | async; as self) {
	@if (associations$ | async; as associations) {
		<article class="document">
			@for (association of associations; track association) {
				<section>
					@if ($any(association.targetElement) !== self) {
						@if (!(association.changeMarker && association.changeMarker.deleted)) {
							<a [routerLink]="getRoute(association)"
								><ng-container
									*ngTemplateOutlet="associationlabel; context: { association: association }"
								></ng-container
							></a>
						}
						@if (association.changeMarker && association.changeMarker.deleted) {
							<div>
								<ng-container
									*ngTemplateOutlet="associationlabel; context: { association: association }"
								></ng-container>
							</div>
						}
					}
					<stages-description-view
						descriptionClass="shift-font-size"
						[html]="$any(association.targetElement).description.html"
					></stages-description-view>
				</section>
			}
		</article>
	}
}
